// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"454":"8ef00351","987":"22ae7f92"}[chunkId] + ".chunk.css";
};